"use client";


import { Button, ButtonProps } from "@/components/ui/button";
import { Loader } from "@/components/ui/loader";
import { ReactNode } from "react";
import { useActionFeedback, useTransitionContext } from "./context";
import { showCenteredToast } from "@/lib/action/feedback";

export type ActionButtonProps = ButtonProps & {
  success?: ReactNode;
  loading?: ReactNode;
  showLoader?: boolean;
  pending?: boolean;
};

import { cn } from "@/lib/utils/utils";
import { useRouter } from "next/navigation";
import { forwardRef } from "react";
import { Action } from ".";
import { Route } from "next";

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  (
    { children, showLoader = true, pending, onClick, className, ...props },
    ref
  ) => {
    const isLoading = pending;
    return (
      <Button
        ref={ref}
        {...props}
        variant={props.variant ?? "default"}
        className={cn(
          `relative overflow-hidden transition-all duration-300 ease-in-out`,
          isLoading && "[&>svg]:hidden",
          isLoading && "pointer-events-none",
          className
        )}
        onClick={onClick}
      >
        {children}
        {isLoading && showLoader && (
          <div
            className={`inset-0 flex items-center justify-center transition-opacity duration-300 ${
              isLoading ? "opacity-100" : "opacity-0"
            }`}
          >
            <Loader state="pending" />
          </div>
        )}
      </Button>
    );
  }
);

ActionButton.displayName = "ActionButton";

export function ActionTrigger<I = void>({
  action,
  input,
  onComplete,
  ...props
}: Omit<ActionButtonProps, "pending"> & {
  action: Action<I>;
  input: I extends void ? undefined : I;
  onComplete?: () => void;
}) {
  const [state, startTransition] = useTransitionContext(props.id);
  const [, setFeedback] = useActionFeedback();
  const router = useRouter();
  const transition = async () => {
    startTransition(async () => {
      
        const feedback = await action(input as I);
        
        if (!!feedback && "redirect" in feedback) {
          router.push(feedback.redirect as Route<string>);
        }
        
        if (!!feedback && "type" in feedback) {
          setFeedback(feedback);
        }

              // Imposta il FeedbackToast restituito
        if (feedback &&'actionResult' in feedback && feedback.actionResult) {
          showCenteredToast(feedback.actionResult.message, feedback.actionResult.status);
        }
        
        // Show the toast message
        onComplete?.();
    });
  };
  return (
    <ActionButton
      {...props}
      onClick={transition}
      type="button"
      pending={state === "pending"}
    />
  );
}
